import SafariError from "../assets/safari_error.png";
import { GlobalLogger } from "./debugLogger";
import { Messages } from "./scanview.types";
import FirefoxVideo from "../assets/videos/firefox.mp4";
import SafariVideo from "../assets/videos/safari.mp4";
import ChromeVideo from "../assets/videos/chrome.mp4";
import CardScanLogo from "../assets/cardscan-logo.png";

export const CardScanLogoURL = CardScanLogo;

export const getBrowserHelperImage = (browserName = "Chrome") =>
  ({
    Firefox: FirefoxVideo,
    Chrome: ChromeVideo,
    Safari: SafariVideo,
    "Mobile Safari": SafariVideo,
    Edge: SafariError,
  }[browserName] || ChromeVideo);

export function dataURLtoFile(dataurl: string, filename: string) {
  const arr: any = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = window.atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

export const calculateGuides = (
  videoRefBg: React.RefObject<HTMLVideoElement>,
  frameDivRef: React.RefObject<HTMLDivElement>
): [number, number, number, number] => {
  const frameDivDimensions =
    frameDivRef.current?.getBoundingClientRect() as any;
  const videoElementDimensions =
    videoRefBg.current?.getBoundingClientRect() as any;

  const heightAspectRatio =
    (videoRefBg.current?.videoHeight || 1) /
    (videoRefBg.current?.videoWidth || 1);
  const videoElementHeight = videoElementDimensions.width * heightAspectRatio;
  const percentageOfScanFrameWidth =
    frameDivDimensions.width / videoElementDimensions.width;
  const percentageOfScanFrameHeight =
    frameDivDimensions.height / videoElementHeight;

  const guideWidth =
    (videoRefBg.current?.videoWidth || 1) * percentageOfScanFrameWidth;
  const guideHeight =
    (videoRefBg.current?.videoHeight || 1) * percentageOfScanFrameHeight;

  const videoCenterX = (videoRefBg.current?.videoWidth || 1) / 2;
  const videoCenterY = (videoRefBg.current?.videoHeight || 1) / 2;

  const xPosition = videoCenterX - guideWidth / 2;
  const yPosition = videoCenterY - guideHeight / 2;

  GlobalLogger.debug(
    `Guide: ${xPosition}, ${yPosition}, ${guideWidth}, ${guideHeight}`,
    "everything"
  );
  return [xPosition, yPosition, guideWidth, guideHeight];
};

export const getHeaderTitle = (
  status: string,
  messageState: Messages,
  isAuto: boolean
) =>
  ({
    cameraLoading: messageState.autoCaptureTitle,
    autoCapture: messageState.autoCaptureTitle,
    manualCapture: messageState.manualCaptureTitle,
    frontsideProcessing: messageState.processingTitle,
    backsidePending: messageState.frontsideCompletedTitle,
    frontsideCompleted: messageState.frontsideCompletedTitle,
    backsideProcessing: messageState.processingTitle,
    postProcessing: messageState.postProcessing,
    success: messageState.completedTitle,
    pending: isAuto
      ? messageState.autoCaptureTitle
      : messageState.manualCaptureTitle,

    error: messageState.errorTitle,
    cameraError: messageState.cameraErrorTitle,
    retry: messageState.retryTitle,
    eligibilityProcessing: messageState.eligibilityProcessing,
    eligibilityError: messageState.eligibilityErrorTitle,
  }[status]);
